import { observable, action, flow, computed, toJS } from 'mobx';
import { get, cloneDeep, isEmpty } from 'lodash';
import { Toast, Modal } from 'antd-mobile';
import Stores from 'config/Stores';
import Serv from './ShoppingCartServ';
import { FileTypeMap } from 'utils/constants';
import {
  getThinUserState,
  getIsUnsubscribeOrSleep
} from 'biz-micro-services-ui/project/middlePlatform/function/globalState';
import Util from 'utils';

const { alert } = Modal;
const defaultListData = {
  data: [],
  isLoading: false,
  pageNum: 1,
  pages: 1
};
class ShoppingCartMod {
  // view层实例
  @observable viewInstance = null;

  // 是否处于管理状态
  @observable onManaging = false;

  // 购物车列表
  @observable cartList = [];

  // 购物车商品关联的秒杀/满赠活动
  @observable flashAndFullActivityList = [];

  //判断购物车列表商品是否有资格购
  @observable list = [];

  // 购物车商品数量
  @observable cartCount = 0;

  // 订单类型 (1 零售订单、2 复消订单)
  @observable orderType = '1';

  // 配货比例(1、1比1配货； 2、1比2配货；3、1比3配货)
  @observable distributionRatio = '';
  // 新零售折扣
  @observable discount = '';
  // 加了资格购后的门槛金额
  @observable totalPureAmount = 0;
  // 记录已选产品项
  @observable selectedItems = {};

  // 是否参加促销活动
  @observable isJoin = true;

  // 记录已选赠品项id
  @observable selectedGiftItems = {};

  // 记录已选赠品所有数据
  @observable selectedGiftListItems = [];

  // 当前临时选择的商品列表
  @observable selectedGiftList = [];

  @observable cartIndex = 0;

  @observable giftList = {};

  // 记录已选赠品对应的活动id
  @observable giftListActivity = [];

  // 赠品类型，1：实物赠品，2：兑换券类，3：虚拟权益
  @observable giftType = '';

  // 赠送数量
  @observable presentCount = '';

  // 赠送方式，1：全部赠送，2：任选几款 3: 任选几件
  @observable presentWay = '';

  @observable switchIndexs = [];

  @observable modalObject = {}; // 不同赠品弹框的一些数据
  // 保存赠品活动id
  @observable actId = '';

  // 记录所有的活动活动id
  @observable allActivityItems = {
    // '0988': {
    //   activityGiftId: '898989'
    // }
  };

  // 确定每一项的时候，生成gKey
  @observable activityDiscountInfoListGkey = [];

  @observable isQuery = false;

  // 每个item满赠活动列表
  @observable activeListValue = [];

  // 切换后选择的满赠活动ID
  @observable selectActivityId = '';

  // query接口返回数据
  @observable queryReturnData = [];

  // 默认赠送礼品活动列表
  @observable defaultActivityList = [];

  @observable bizDefaultGiveawayReqDto = {};

  @observable modalShow = false;

  @observable modalContent = '';

  // 产品信息
  @observable productInfo = {};

  // 多规格商品
  @observable moreSpecificationsData = [];
  // 选中的多规格商品
  @observable checkItem = {};
  // 满赠阶梯信息
  @observable jtInfo = {};

  @observable showSkuModal = false;
  // currentCartItem = {};

  @observable addressInfo = {};

  @observable freeShippingData = {
    amount: 0, //还差多少包邮
    showType: 0 //0-无包邮 1-为满包邮  2-包邮
  };

  @observable recommendListData = defaultListData;

  fastPreviewViewableItems = []; //快速预览商品

  @action
  changeState(obj) {
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }

  @action
  setRecommendListArray = () => {
    this.recommendListData = defaultListData;
  };
  /**
   * 乐道，零售 1:2及以上
   */
  @computed
  get ldFloor() {
    return Stores.AppMod.isLD && this.orderType == '1' && this.distributionRatio > 1;
  }

  @computed
  get orderTypeList() {
    const userInfo = Stores.AppMod.userInfo || {};
    const orderLabelList = (userInfo && userInfo.orderLabelList) || [];
    const list =
      orderLabelList[0] && orderLabelList[0]['label']
        ? [
            {
              value: '1',
              label: (orderLabelList[0] && orderLabelList[0]['label']) || '零售订单'
            }
          ]
        : [];
    if (Stores.AppMod.userType != 1 && orderLabelList.length === 2 && orderLabelList[1].value) {
      list.push({
        value: '2',
        label: (orderLabelList[1] && orderLabelList[1]['label']) || '复消订单'
      });
    }
    if (this.isVipRebuy) {
      list.push({ value: '10', label: 'VIP复购订单' });
    }
    return list;
  }

  @computed
  get distributeRadioList() {
    return Stores.AppMod.userInfo.distributionRatioList || [];
  }

  @computed
  get discountList() {
    return Stores.AppMod.userInfo.discountList || [];
  }

  @computed
  get isDiscountMode() {
    return false;
    // return Stores.AppMod.userInfo.orderVersion == 1
  }

  @computed
  get cartTypeList() {
    // 设置children
    let arr = [];
    this.orderTypeList.forEach((item) => {
      let obj = {};
      obj.value = item.value;
      obj.label = item.label;
      obj.children = this.col2List[item.value] || [];
      arr.push(obj);
    });

    return arr;
    // return [this.orderTypeList, this.distributeRadioList['1']];
  }

  /**
   * 处理配送比例，根据接口返回设置
   */
  @action
  handleDistributionRatio() {
    const { userType } = Stores.AppMod;
    if (!this.distributionRatio) {
      if (this.distributeRadioList && Object.keys(this.distributeRadioList).length > 0) {
        this.distributionRatio =
          userType == 1 || this.isVipRebuy ? 1 : this.distributeRadioList[this.orderType][0].value;
      }
    }
  }

  /**
   * 处理折扣比例，根据接口返回设置
   */
  @action
  handleDiscount() {
    if (!this.discount) {
      if (this.isDiscountMode) {
        this.discount = this.discountList['1'][0].value;
        this.distributionRatio = 1;
      } else {
        this.distributionRatio = '';
      }
    }
  }
  // 订单应付满减金额/bv
  @computed
  get orderMinAmount() {
    let text = '';
    this.orderTypeList.forEach((item) => {
      if (item.value == this.orderType && this.discountList[item.value]) {
        this.discountList[item.value].forEach((subItem) => {
          if (this.discount == subItem.value) {
            text = subItem.orderMinAmount;
          }
        });
      }
    });
    return text;
  }
  // 最小金额提示
  @computed
  get minNumberTip() {
    let text = '';
    if (this.orderMinAmount > 0) {
      if (this.orderType * 1 == 1) {
        text = `订单应付满${Util.formatMoney({ value: this.orderMinAmount, showPrefix: false, showCurrencyName: true, precision: 0 })}可用`;
      } else {
        text = `订单应付满${this.orderMinAmount}BV可用`;
      }
    }
    return text;
  }

  @action
  changeVideoToImage = () => {
    console.log('changeVideoToImage');
    const list = cloneDeep(toJS(this.recommendListData.data));
    list.forEach((item, index) => {
      item.inView = this.fastPreviewViewableItems.includes(index);
      if (!item.inView) {
        item.isFirstClick = true;
      }
    });
    this.recommendListData.data = list;
  };

  @action
  changePaused = (paused, item) => {
    const list = cloneDeep(toJS(this.recommendListData.data));
    const currentItem = list.find((listItem) => listItem.id === item.id) || {};
    if (isEmpty(currentItem)) return;
    list.forEach((item, index) => {
      item.inView = this.fastPreviewViewableItems.includes(index);
    });
    // 将列表里内其他正在播放的视频暂停
    if (!paused) {
      const playIndex = list.findIndex((product) => {
        const mediaRespDtoList = product.mediaRespDtoList || [];
        const hasVideo = mediaRespDtoList.some((media) => media.fileType == FileTypeMap.VIDEO);
        return product.paused === false && hasVideo;
      });
      console.log('playIndex', playIndex);
      if (playIndex > -1) {
        const pausedItem = list[playIndex];
        pausedItem.paused = true;
        pausedItem.isFirstClick = !pausedItem.inView;
      }
    }
    currentItem.paused = paused;
    currentItem.isFirstClick = !currentItem.inView;
    this.recommendListData.data = list;
  };

  /**
   * 得到活动数组的唯一key
   */
  getActivityListKey = (activityList) => {
    if (!(activityList && activityList.length > 0)) {
      return '';
    }
    if (activityList && activityList.length === 1) {
      return activityList[0].activityId;
    }
    // 把商品活动ID排序，从低到高
    const sortNumber = (a, b) => {
      return a - b;
    };
    const activityListId = activityList
      .map((item) => item.activityId)
      .sort(sortNumber)
      .join(',');

    return activityListId;
  };

  /**
   * 添加商品到购物车
   */
  addCart = flow(function* (params) {
    const shareId = localStorage.getItem('shareIdVistor') || void 0;
    const n = Array.isArray(params) ? params : { ...params, shareId };
    try {
      yield Serv.addCart(n);
      // 神策数据发送
      window.sensors.track('shopcartAdd', {
        arr: JSON.stringify([
          {
            commodity_id: params.itemSerial,
            commodity_name: params.itemName,
            quantity: params.itemNum || '',
            price: params.price || '',
            source: 'H5' // 来源
          }
        ])
      });
      return true;
    } catch (error) {}
    return false;
  });

  /**
   * 添加商品到甄选商城购物车
   *
   * 0-积分商城 1-异业商城
   */
  addSelectMallCart = flow(function* (params, type) {
    try {
      yield Serv.addSelectMallCart(params, type);

      return true;
    } catch (error) {
      return false;
    }
  });

  /**
   * 获取购物车列表
   */
  getCartList = flow(function* (isInit = false) {
    if (!this.orderType) {
      return;
    }

    const params = {
      orderType: this.orderType == '10' ? '1' : this.orderType,
      distributionRatio: this.distributionRatio || '-1',
      discount: this.discount
    };
    try {
      Toast.loading('请稍候', 100);
      const { data } = yield Serv.getCartList(params);
      // 查询满赠阶梯信息
      // Array.isArray(toJS(data)) && data.forEach(f=>{
      //  let manzengArr = Array.isArray(f.activityList) ? f.activityList.filter(fn=>fn.activityType==3) : []
      //  Array.isArray(toJS(manzengArr)) && manzengArr.forEach(v=>{
      //   this.queryJFInfo({
      //     activityId: v.activityId,
      //     itemList: f.itemList

      //   })
      //  })
      // })
      this.cartList = data || [];
      const activityRes = yield Serv.getActivityList(params);
      this.flashAndFullActivityList = activityRes.data || [];
      Toast.hide();
      this.allActivityItems = {};
      this.freeShippingData = { amount: 0, showType: 0 };
      this.cartList = this.addActivityProductsKeys(toJS(this.cartList));
      // 对已选的分组，进行请求加价购
      this.cartList.forEach((cart, index) => {
        cart.itemList.forEach((item) => {
          if (this.selectedItems[item.id]) {
            this.getIncPriceShopMsg(cart.gKey);
          }
        });
      });
      // vip复购默认选中1:1
      if (this.isVipRebuy && this.orderType != '10') {
        this.orderType = '10';
        this.distributionRatio = '1';
      }

      if (
        isInit &&
        this.col2List[this.orderType] &&
        toJS(this.col2List[this.orderType]).length == 2
      ) {
        this.distributionRatio = this.col2List[this.orderType]['1']['value'];
        this.getCartList();
      }

      //【前端 | H5】钻卡用户在选择商品的时候能优先识别1:2配货
      // console.log(toJS(this.col2List[this.orderType]),'---->666');
      if (
        Stores.AppMod.userInfo.cardType == 3 &&
        Stores.AppMod.userInfo.systemType == 0 &&
        toJS(this.col2List[this.orderType]).find((v) => v.value == 2)
      ) {
        // this.orderType = '1';
        // this.distributionRatio = '2';
      }

      if (!this.isVipRebuy && this.orderType == '10') {
        this.orderType = '1';
        this.distributionRatio = '1';
        this.getCartList();
      }
      return data;
    } catch (error) {}
    return null;
  });

  // 获取所有活动商品
  @action
  getAllGoods = (data, params) => {
    const { keyword } = params || {};
    let allGoods = [];
    data.forEach((item) => {
      const itemList = (item && item[keyword]) || [];
      itemList.forEach((subItem) => {
        allGoods.push(subItem && subItem.id);
      });
    });
    this.getALLActivityItems(allGoods);
  };

  // 获取所有活动 每个商品id 对应的活动
  getALLActivityItems = flow(function* (allGoods) {
    try {
      const { data } = yield Serv.getAllActivityItems(allGoods);
      this.allActivityItems = data || {};
      this.getAllActivityGiftList();
    } catch (error) {}
  });

  /**
   * 查询阶梯促销-满赠信息
   */
  queryJFInfo = flow(function* (params, cartItemIndex) {
    const trueKeys = Object.keys(this.selectedItems).filter(
      (key) => this.selectedItems[key] === true
    );
    console.log(toJS(this.selectedItems), trueKeys, '---->66666');

    params.itemList = params.itemList.filter((fItem) => trueKeys.includes(fItem.id));
    // if(params.itemList.length == 0) {
    //   return
    // }
    try {
      const { data, resultCode, resultMsg } = yield Serv.queryJFInfo(params);
      if (resultCode == 0) {
        this.jtInfo = {
          ...this.jtInfo,
          [params.activityId + `${cartItemIndex}`]: data
        };
      }
      return data;
    } catch (error) {}
  });

  // 查询促销阶梯加价购信息
  queryFloorInfo_addSale = flow(function* (params) {
    console.log('queryFloorInfo_addSale', params);
    try {
      // Todos: 请求发起写在这里
      // const { data, resultCode, resultMsg } = yield Serv.testFunc(params)
      // if(resultCode == 0){
      // }
    } catch (err) {
      console.log(err);
    }
  });
  // queryJTInfoByItemNum = flow(function*(params) {
  //   //  console.log(params,'----queryJTInfoByItemNum');
  //    const {cartItem, id, value} = params;
  //    const {activityList, itemList} = cartItem
  //    let manzengArr = Array.isArray(toJS(activityList)) ? activityList.filter(fn=>fn.activityType==3) : []
  //    Array.isArray(toJS(manzengArr)) && manzengArr.forEach(v=>{
  //     this.queryJFInfo({
  //       activityId: v.activityId,
  //       itemList: Array.isArray(toJS(itemList)) &&  itemList.map(m=>{
  //         if(m.id == id){
  //           return {
  //             ...m,
  //             itemNum: value
  //           }
  //         }else{
  //           return m
  //         }
  //       })

  //     })
  //     })
  // });
  /**
   * 根据商品获取活动信息
   */
  getActivityInfosByProductId = flow(function* (params) {
    try {
      const { data, resultCode, resultMsg } = yield Serv.getActivityInfosByProductId(params);
      return data;
    } catch (error) {}
  });

  // 过滤出所有默认赠送的活动
  getAllActivityGiftList = flow(function* () {
    try {
      const { data } = yield Serv.getAllActivityGiftList();
      this.defaultActivityList = data || {};
    } catch (error) {}
  });

  // 获取默认的赠品
  @action
  getDefaultGiftList() {
    const { defaultActivityList, bizDefaultGiveawayReqDto } = this;
    const { freeItem = [], giftList = [] } = bizDefaultGiveawayReqDto || {};
    if (Array.isArray(toJS(defaultActivityList)) && defaultActivityList.length > 0) {
      let idList = [];
      defaultActivityList.forEach((item) => {
        const { activityId } = item;
        idList = [...idList, activityId];
      });
      this.getdefaultActivityGiftList(idList.join(',')).then((res) => {
        if (res) {
          // 每个活动对应的默认赠品信息
          const { giftItems, couponRightsList } = res || {};

          // const freeItemList = [...freeItem, ...res.giftItems];
          // const giftListList = [...giftList, ...res.couponRightsList];
          // let newObject = {
          //   freeItem: freeItemList,
          //   giftList: giftListList,
          // };
          // this.changeState({bizDefaultGiveawayReqDto: newObject});
        }
      });
    }
  }

  /**
   * 获取满赠列表
   */
  getdefaultActivityGiftList = flow(function* (theQuestId) {
    try {
      const trueKeys = Object.keys(this.selectedItems).filter(
        (key) => this.selectedItems[key] === true
      );

      const { data, resultCode } = yield Serv.getActivityIdsGiftList({
        activityIds: theQuestId.split(','),
        itemList:
          this.cartList[this.cartIndex]['itemList'] &&
          this.cartList[this.cartIndex]['itemList'].filter((fl) => trueKeys.includes(fl.id))
      });

      let giftItems = {};
      let couponRightsList = {};
      if (`${resultCode}` == '0') {
        data.forEach((datas, index) => {
          let giftType = get(datas, 'giftType');
          let presentCount = get(datas, 'presentCount');
          let activityId = get(datas, 'activityId');
          let presentWay = get(datas, 'presentWay');
          let newgiftItemList = [];
          if (get(datas, 'giftItemList', []) && get(datas, 'giftItemList', []).length > 0) {
            newgiftItemList = get(datas, 'giftItemList', []).map((item) => {
              item.activityId = activityId;
              item.giftMulti = datas.giftMulti;
              return item;
            });
          }
          let newCouponList = [];
          if (get(datas, 'couponList', []) && get(datas, 'couponList', []).length > 0) {
            newCouponList = get(datas, 'couponList', []).map((item) => {
              item.activityId = activityId;
              item.giftMulti = datas.giftMulti;
              item.couponName = item.couponName || item.giftCouponName;
              item.couponType = item.couponType !== undefined ? item.couponType : item.deductionType;
              item.couponValue = item.couponValue !== undefined ? item.couponValue : item.giftValue;

              return item;
            });
          }
          let newRightsList = [];
          if (get(datas, 'rightsList', []) && get(datas, 'rightsList', []).length > 0) {
            newRightsList = get(datas, 'rightsList', []).map((item) => {
              item.activityId = activityId;
              // item.giftMulti = datas.giftMulti

              return item;
            });
          }
          let newGiftList = [];
          let theGiftList;
          if (+giftType === 5) {
            // 组合类型：合并实物和优惠券列表
            theGiftList = [...newgiftItemList, ...newCouponList];
            // 解析子项类型
            theGiftList.forEach((item) => {
              item.resolvedGiftType = item.couponType !== undefined ? 2 : 1;
            });
          } else {
            theGiftList = [newgiftItemList, newCouponList, newRightsList][datas.giftType - 1] || [];
          }
          if (presentWay == 1) {
            newGiftList = theGiftList.map((item) => {
              const {
                id,
                price: itemPrice,
                couponName,
                giftCount,
                itemName,
                skuSerial,
                giftType: itemGiftType
              } = item || {};
              const effectiveType = +giftType === 5 ? item.resolvedGiftType : +datas.giftType;
              let commonObj = {
                groupKey: 1024,
                itemNum: giftCount,
                activityIdList: [activityId],
                giftType: effectiveType
              };
              if (effectiveType === 2) {
                commonObj = {
                  ...commonObj,
                  itemName: couponName,
                  giftNum: giftCount,
                  giftId: id
                };
              } else {
                commonObj = {
                  ...commonObj,
                  itemName,
                  skuSerial,
                  itemPrice,
                  itemSerial: id
                };
              }
              return commonObj;
            });
          } else if (presentWay == 2) {
            let count = presentCount;
            theGiftList.forEach((item) => {
              if (count > 0) {
                const {
                  itemSerial,
                  price: itemPrice,
                  giftCount: itemNum,
                  itemName,
                  skuSerial,
                  giftType: itemGiftType,
                  giftNum,
                  giftId
                } = item || {};
                const effectiveType = +giftType === 5 ? item.resolvedGiftType : +datas.giftType;
                let commonObj = {
                  groupKey: 1024,
                  itemName,
                  itemNum,
                  activityIdList: [activityId]
                };
                if (effectiveType === 2) {
                  commonObj = { ...commonObj, giftType: effectiveType, giftNum, giftId };
                } else {
                  commonObj = { ...commonObj, skuSerial, itemPrice, itemSerial };
                }
                newGiftList.push(commonObj);
                count--;
              }
            });
          }
          if (+giftType === 5) {
            // 组合类型：按子项类型分别存入
            newGiftList.forEach((item) => {
              if (item.giftType === 2) {
                couponRightsList[activityId] = couponRightsList[activityId] || [];
                couponRightsList[activityId].push(item);
              } else {
                giftItems[activityId] = giftItems[activityId] || [];
                giftItems[activityId].push(item);
              }
            });
          } else if (giftType == 1) {
            giftItems[activityId] = newGiftList;
          } else {
            couponRightsList[activityId] = newGiftList;
          }
        });
        return {
          giftItems,
          couponRightsList
        };
      }
    } catch (e) {
      console.log(e);
    }
  });

  @computed get hideTitle() {
    const { cartTypeList } = this;
    const newCartTypeList = cartTypeList.filter((item) => {
      const { children } = item || {};
      if (Array.isArray(toJS(children)) && toJS(children).length > 0) {
        return item;
      }
    });

    if (Array.isArray(newCartTypeList) && newCartTypeList.length === 1) {
      const { children } = newCartTypeList[0];
      const filterValue = toJS(children).filter((res) => {
        const { value } = res || {};
        if (+value !== -1) {
          return res;
        }
      });
      if (Array.isArray(filterValue) && filterValue.length === 1) {
        return true;
      }
    }
    return false;
  }

  /**
   * 获取购物车商品数量
   */
  getCartCount = flow(function* () {
    try {
      const { data, resultCode } = yield Serv.getCartCount();
      if (`${resultCode}` == '0') {
        this.cartCount = data;
      }
    } catch (error) {}
  });

  /**
   * 获取甄选商城购物车商品数量
   */
  querySelectMallCartNum = flow(function* () {
    try {
      const { data, resultCode } = yield Serv.querySelectMallCartNum();
      if (`${resultCode}` == '0') {
        this.cartCount = data;
      }
    } catch (error) {}
  });

  // 是否显示资格购-干细胞配货比例
  @computed
  get isShopMasterMode() {
    return false;
    // return Object.keys(this.masterDistributionList).length > 0
  }

  // 资格购-干细胞配货比例
  @computed
  get masterDistributionList() {
    return {};
    // let {orderType} = this
    // let arr = []
    // for (const cartItem of this.cartList) {
    //   if (cartItem.activityList) {
    //     for (const item of cartItem.activityList) {
    //       if (item.allowDistributionRatio) {
    //         arr.concat(item.allocateCargoScale.split(','))
    //       }
    //     }
    //   }
    // }
    // if (arr.length > 0) {
    //   let newArr = new Set(arr)
    //   newArr = Array.from(newArr).map(item => {
    //     return {
    //       label: `1:${item} 配货`,
    //       value: item
    //     }
    //   })
    //   if (newArr.length > 1) {
    //     return {orderType: [{label: '未选择', value: "-1"}, ...newArr]}
    //   }
    //   return {orderType: newArr}
    // } else {
    //   return {}
    // }
  }

  // 顶部分类列第二栏
  @computed
  get col2List() {
    let col2 = {};
    if (this.isShopMasterMode) {
      col2 = this.masterDistributionList;
    } else {
      if (this.isDiscountMode) {
        col2 = this.discountList;
      } else {
        col2 = this.distributeRadioList;
      }
    }
    return col2;
  }

  /**
   * 是否有购物车数据
   */
  @computed
  get hasCartData() {
    return this.cartList && this.cartList.length > 0;
  }

  @computed
  get cartTypeText() {
    let text = '';
    for (let i = 0; i < this.orderTypeList.length; i++) {
      if (`${this.orderType}` == this.orderTypeList[i].value) {
        text = this.orderTypeList[i].label;
        break;
      }
    }
    let checkItem =
      this.isDiscountMode && !this.isShopMasterMode
        ? `${this.discount}`
        : `${this.distributionRatio}`;
    if (this.col2List[this.orderType]) {
      for (let i = 0; i < this.col2List[this.orderType].length; i++) {
        if (checkItem == this.col2List[this.orderType][i].value) {
          text = `${text}，${this.col2List[this.orderType][i].label}`;
          break;
        }
      }
    }
    return this.isVipRebuy ? 'VIP复购订单' : text;
  }

  @action
  clearObjDate() {
    this.selectedItems = {};
    // 清除已经选择的赠品
    this.selectedGiftListItems = [];
    this.selectedGiftItems = {};
    this.selectedGiftList = [];
    // 记录所有的活动活动id
    this.allActivityItems = {};
    // 确定每一项的时候，生成gKey
    this.activityDiscountInfoListGkey = [];
  }

  @action
  onCartTypePick(value) {
    const { userType } = Stores.AppMod;
    this.orderType = value[0];
    if (this.isDiscountMode && !this.isShopMasterMode) {
      this.discount = value[1];
    } else {
      // 普客未选择时，默认1：1
      this.distributionRatio = value[1];
    }

    this.clearObjDate();

    this.getCartList().then(() => {
      this.resetSelectedItems(false);
    });
  }

  /**
   * 重新设置选中状态（订单类型、是否管理状态改变后调用）
   * showToast: 是否显示提示
   */
  @action
  resetSelectedItems(showToast) {
    let flag = false;
    let listdata = [];
    for (const cartItem of this.cartList) {
      listdata = cartItem.activityList;
      // console.log(listdata,'listdata1111');

      for (const item of cartItem.itemList) {
        console.log(this.selectedItems[item.id]);
        if (this.selectedItems[item.id] && !this.getItemCanSelect(item, listdata)) {
          // 不支持订单类型的产品变为不选中
          delete this.selectedItems[item.id];
          this.selectedItems = { ...toJS(this.selectedItems) };
          flag = true;
        }
      }
    }
    this.clearIncPriceShop([...new Array(this.cartList.length).keys()]);
    if (showToast && flag) {
      Toast.info('因订单类型变化，部分产品不可以下单', 2);
    }
  }

  /**
   * 加减加价购商品
   */
  @action
  changeCountIncPrice(cartItemIndex, index, count) {
    let cartList = [...this.cartList];
    cartList[cartItemIndex].incPriceShop.items[index].itemNum = +count;
    this.cartList = cartList;
  }

  @action
  changeRandomCountIncPrice(cartItemIndex, count) {
    let cartList = [...this.cartList];
    cartList[cartItemIndex].incPriceShop.items.map((res, idx) => {
      idx === 0 ? (res.itemNum = +count >= 0 ? +count : 0) : (res.itemNum = 0);
    });
    this.cartList = cartList;
  }

  /**
   * 清除加价购数据
   */
  @action
  clearIncPriceShop(indexs) {
    for (let index of indexs) {
      this.cartList[index].incPriceShop = null;
    }
  }

  /**
   * 已选的产品数量
   */
  @computed
  get selectedCount() {
    let count = 0;
    for (const cartItem of this.cartList) {
      for (const item of cartItem.itemList) {
        if (this.selectedItems[item.id]) {
          count += Number(item.itemNum);
        }
      }
    }
    return count;
  }

  /**
   *选中商品
   * @memberof ShoppingCartMod
   */
  @action
  changeSelected(id, isSelected, cartItemIndex, actId) {
    console.log('选中商品', '------>');
    let selectedItems = { ...this.selectedItems };
    selectedItems[id] = !isSelected;
    this.selectedItems = selectedItems;
    this.getDiscountBatch(() => {
      this.changeSelected(id, !isSelected, cartItemIndex);
    }, cartItemIndex);
    const hasSelected = (this.cartList[cartItemIndex].itemList || []).find(
      (item) => this.selectedItems[item.id]
    );
    if (!hasSelected) {
      this.clearIncPriceShop([cartItemIndex]);
    } else {
      this.getIncPriceShopMsg(this.cartList[cartItemIndex].gKey);
      // this.selectDefaultGift(); // 选择所有产品
      //调用完getDiscountBatch后，统一调用
      // this.handleSelectedGiftListFan(cartItemIndex, actId);
    }

    // this.queryJFInfo({

    // })
  }

  // 查询阶梯信息
  queryJt = flow(function* (cartItemIndex, infoList) {
    const { activityList, itemList } = toJS(this.cartList[cartItemIndex]);

    let manzengArr = []; // 满赠活动数组
    let promiseList_manzeng = []; // 满赠批量请求

    (activityList || []).map((v) => {
      // 满赠
      if (v.activityType == 3) {
        manzengArr.push(v);
        promiseList_manzeng.push({
          activityId: v.activityId,
          itemList,
          cartItemIndex
        });
      }
    });

    // 请求阶梯促销-满赠信息
    yield Promise.all(
      promiseList_manzeng.map(async (item, idx) => {
        console.log('请求阶梯促销-满赠', idx, item);
        return await this.queryJFInfo(
          {
            activityId: item.activityId,
            itemList: item.itemList
          },
          item.cartItemIndex
        );
      })
    ).then((res) => {
      console.log('请求阶梯促销-满赠 success', res);
    });
  });

  @action
  changeSelectedGift(id, isSelected, activityId, thisCartIndex, count, presentWay, sign, isSku) {
    if (presentWay == 1 && sign && !isSku) return;
    let value = JSON.parse(JSON.stringify(this.selectedGiftItems));
    value = Array.from(value);
    let object = value[+thisCartIndex] || {};
    object[activityId] = object[activityId] || {};
    if (count == 1 && presentWay != 3) {
      id && (object[activityId][id] = !isSelected);
      console.log(object[activityId]);
      for (var k in object[activityId]) {
        if (k != id) {
          object[activityId][k] = false;
        }
      }
    } else {
      id && (object[activityId][id] = !isSelected);
    }
    // console.log(object[activityId]);
    // id && (object[activityId][id] = !isSelected);
    const returnValue = Object.values(object[activityId]).findIndex((item) => item);
    // if (returnValue === -1) {
    //   Toast.info('赠品至少选择一个哦');
    //   return false;
    // }
    if (returnValue === -1 && presentWay != 3) {
      Toast.info('赠品至少选择一个哦');
      return false;
    }

    // 赠品全选逻辑
    if (sign && presentWay == 1 && returnValue != count - 1 && !isSku) {
      return false;
    }
    value[+thisCartIndex] = object;
    this.selectedGiftItems = value;
    return true;
  }

  /**
   * 记录所有的活动id  3是赠品
   */
  @action
  selectedActivityItems(gKey = '10086', actId, type) {
    let tableObj = {
      3: 'activityGiftId'
    };
    if (this.allActivityItems[gKey]) {
      this.allActivityItems[gKey][tableObj[type]] = actId;
    } else {
      this.allActivityItems[gKey] = {};
      this.allActivityItems[gKey][tableObj[type]] = actId;
    }
  }

  /**
   * 获取满赠列表
   */
  getActivityGiftList = flow(function* ({ activityIds }, indexValue) {
    const oldGiftList = cloneDeep(toJS(this.giftListActivity)) || [];
    try {
      const trueKeys = Object.keys(this.selectedItems).filter(
        (key) => this.selectedItems[key] === true
      );
      console.log(this.cartIndex, '购物车的索引', trueKeys);
      let { data, resultCode } = yield Serv.getActivityIdsGiftList({
        activityIds: activityIds.split(','),
        itemList:
          this.cartList[this.cartIndex]['itemList'] &&
          this.cartList[this.cartIndex]['itemList'].filter((fl) => trueKeys.includes(fl.id))
      });

      let modalObject = {};
      let AllGiftList = {};
      let modalObjectList = this.modalObject || [];
      let AllGiftListActivity = this.giftListActivity || [];
      if (`${resultCode}` == '0') {
        data.forEach((datas, index) => {
          let giftItemList = get(datas, 'giftItemList') || [];
          let couponList = get(datas, 'couponList') || [];
          let rightsList = get(datas, 'rightsList') || [];
          let giftType = get(datas, 'giftType');
          let activityId = get(datas, 'activityId');
          let presentCount = get(datas, 'presentCount');
          let presentWay = get(datas, 'presentWay');
          let random = get(datas, 'random');
          let shared = get(datas, 'shared');
          let blessingBagAlias = get(datas, 'blessingBagAlias');
          let blessingBagImg = get(datas, 'blessingBagImg');
          let theGiftList;
          if (+giftType === 5) {
            // 组合类型：合并实物和优惠券列表
            theGiftList = [...giftItemList, ...couponList];
            theGiftList.forEach((item) => {
              item.resolvedGiftType = item.couponType !== undefined ? 2 : 1;
            });
          } else {
            theGiftList = [giftItemList, couponList, rightsList][giftType - 1];
          }
          let hisGift = [];
          oldGiftList.map((oldGift) => {
            for (const k in oldGift) {
              if (k == activityId) {
                hisGift = oldGift[k];
              }
            }
          });
          let newTheGiftList = theGiftList.map((itemVal) => {
            itemVal.presentWay = presentWay;
            itemVal.presentCount = presentCount;
            itemVal.random = random;
            itemVal.blessingBagAlias = blessingBagAlias;
            itemVal.blessingBagImg = blessingBagImg;
            itemVal.giftMulti = datas.giftMulti;
            if (!!hisGift.length && !!itemVal.subGiftItemSelectRespDtoList) {
              hisGift.forEach((el) => {
                if (el.itemSerial == itemVal.itemSerial) {
                  itemVal.subGiftItemSelectRespDtoList = el.subGiftItemSelectRespDtoList;
                }
              });
            }
            return itemVal;
          });
          AllGiftList[activityId] = newTheGiftList;
          let thisModalObject = {
            giftType,
            presentCount,
            presentWay,
            random,
            shared,
            blessingBagAlias,
            blessingBagImg
          };
          modalObject[activityId] = thisModalObject;
          if (presentWay == 1) {
            theGiftList.forEach((item) => {
              const effectiveType = +giftType === 5 ? item.resolvedGiftType : +giftType;
              const hasInventory = effectiveType === 2 || item.availableStock > 0;
              if (!item.subGiftItemSelectRespDtoList && hasInventory) {
                this.changeSelectedGift(
                  effectiveType === 1 ? item.itemSerial : item.id,
                  false,
                  activityId,
                  indexValue,
                  presentCount,
                  presentWay
                );
              }
            });
          }
          console.log('9999999');
          if (presentWay == 2) {
            // 限制数量的自上而下选中可选赠品
            theGiftList.forEach((item, index) => {
              const effectiveType = +giftType === 5 ? item.resolvedGiftType : +giftType;
              const hasInventory = effectiveType === 2 || item.availableStock > 0;
              if (
                index < (random ? theGiftList.length : presentCount) &&
                !item.subGiftItemSelectRespDtoList &&
                hasInventory
              ) {
                this.changeSelectedGift(
                  effectiveType === 1 ? item.itemSerial : item.id,
                  false,
                  activityId,
                  indexValue,
                  presentCount,
                  presentWay
                );
              }
            });
          } else if (presentWay == 3) {
            // 限制数量的自上而下选中可选赠品
            // 经产品更改需求  presentWay==3默认不选
            // newTheGiftList.forEach((item, index) => {
            //   if ((index < (random ? newTheGiftList.length : presentCount)) && !item.subGiftItemSelectRespDtoList) {
            //     item.itemSelectNum = 1
            //     this.changeSelectedGift(
            //       giftType == 1 ? item.itemSerial : item.id,
            //       false,
            //       activityId,
            //       indexValue,
            //       presentCount,
            //       presentWay,
            //     );
            //   }
            // });
            // AllGiftList[activityId] = newTheGiftList;
          }
        });
        modalObjectList[indexValue] = modalObject;
        this.modalObject = modalObjectList;
        if (AllGiftListActivity.length - 1 < indexValue) {
          for (let i = 0; i < indexValue; i++) {
            !AllGiftListActivity[i] && (AllGiftListActivity[i] = '');
          }
        }
        AllGiftListActivity[indexValue] = AllGiftList;
        this.giftList = AllGiftList;
        this.giftListActivity = AllGiftListActivity;
        console.log(AllGiftList, 'AllGiftListAllGiftListAllGiftList');
        this.handleSelectedGiftList(indexValue, AllGiftList);
      }
    } catch (error) {
      console.log(error);
    }
  });

  // 正向选择
  @action
  handleSelectedGiftList(thisCartIndex, AllGiftList) {
    let AllSelectedGiftList = {};
    let selectedGiftItems = toJS(this.selectedGiftItems);
    console.log(selectedGiftItems, 'selectedGiftItems is ？？？？');
    let selectedValue = [...this.selectedGiftListItems];
    let giftKeys = Object.keys(AllGiftList || toJS(this.giftList));
    const itemValue = selectedGiftItems[thisCartIndex];
    giftKeys.forEach((items, index) => {
      // 选中的满赠礼品循环[[满赠1],[满赠2]]
      let selectedGiftList = [];
      (AllGiftList || toJS(this.giftList))[items].forEach((item) => {
        const effectiveType = item.resolvedGiftType !== undefined ? item.resolvedGiftType : item.giftType;
        let id = effectiveType == 1 ? item.itemSerial : item.id;
        itemValue &&
          itemValue[items] &&
          Object.keys(itemValue[items]).forEach((it) => {
            // 循环已选择的赠品
            if ((itemValue[items][it] && it == id) || (!!item.random && it == id)) {
              // 选中状态的赠品和满赠的赠品相同;
              if (
                !toJS(item.subGiftItemSelectRespDtoList) ||
                (item.subGiftItemSelectRespDtoList &&
                  item.subGiftItemSelectRespDtoList.some((el) => el.isSelected)) ||
                item.presentWay == 3
              ) {
                selectedGiftList.push(item); // 存储其中 一个满赠活动的满赠的产品
              } else {
                itemValue[items][it] = false;
              }
            }
          });
      });
      AllSelectedGiftList[items] = selectedGiftList;
      this.selectedGiftItems = selectedGiftItems;
    });
    // 将该组下的多个满赠赋值到该分组内容下
    if (+thisCartIndex >= 0) {
      selectedValue[thisCartIndex] = AllSelectedGiftList;
    } else {
      selectedValue[this.cartIndex] = AllSelectedGiftList;
    }
    // selectedValue.forEach((selecItem) => {
    //   selecItem && Object.values(selecItem).forEach(__item => {
    //     __item && __item.length && __item.forEach((__sku, sku_idx) => {
    //       // 删除有sku且未选中sku的赠品
    //       if (toJS(__sku.subGiftItemSelectRespDtoList) &&
    //       !__sku.subGiftItemSelectRespDtoList.some(el => el.isSelected)) {
    //         __item.splice(sku_idx, 1);
    //       }
    //     });
    //   });
    // });
    this.selectedGiftListItems = selectedValue;
  }

  // 反向选择渲染  将赠品全部默认选中
  @action
  handleSelectedGiftListFan(index, activityId) {
    // cartIndex 记录是哪个分组的
    this.cartIndex = index;
    if (!Array.isArray(activityId) && activityId.length > 0) {
      activityId = [activityId];
    }
    if (Array.isArray(activityId) && activityId.length > 0) {
      activityId.length === 1
        ? this.getActivityGiftList({ activityIds: activityId[0] }, index)
        : this.getActivityGiftList({ activityIds: activityId.join(',') }, index);
    }
  }

  @action
  changeSelectedAll(param) {
    this.cartIndex = 0; // 全选重置当前选中项
    // this.cartList.length > 0 && toJS(this.cartList).map((item, index) => {
    //   let ids = [];
    //   item.activityList && item.activityList.map((inerItem) => {
    //       inerItem.activityType * 1 === 3 && ids.push(inerItem.activityId);
    //   });
    //   this.handleSelectedGiftListFan(index, ids.join(','));
    // });
    let selectedItems = { ...this.selectedItems };
    let listdata = [];
    for (const cartItem of this.cartList) {
      listdata = cartItem.activityList;
      // console.log(listdata,'listdata2222');
      for (const item of cartItem.itemList) {
        if (param * 1 === 1) {
          selectedItems[item.id] = false;
          if (this.getItemCanSelect(item, listdata)) {
            selectedItems[item.id] = false;
          }
        } else {
          if (!this.isSelectedAll) {
            if (this.getItemCanSelect(item, listdata)) {
              selectedItems[item.id] = true;
            }
          } else {
            selectedItems[item.id] = false;
            if (this.getItemCanSelect(item, listdata)) {
              selectedItems[item.id] = false;
            }
          }
        }
      }
    }
    this.selectedItems = selectedItems;
    for (let i = 0; i < this.cartList.length; i++) {
      if (this.isSelectedAll) {
        this.getIncPriceShopMsg(this.cartList[i].gKey);
      }
    }
    console.log('********', selectedItems);
    this.getDiscountBatch(() => {
      this.changeSelectedAll();
    });
  }
  /**
   * 是否vip复购
   */
  @computed
  get isVipRebuy() {
    if (!this.cartList || this.cartList.length == 0) {
      return false;
    }
    let flag = false;
    for (const cartItem of this.cartList) {
      if (cartItem.activityList) {
        for (const item of cartItem.activityList) {
          if (item.vipUpgradeActivity === 1) {
            flag = true;
            break;
          }
        }
      }
    }
    return flag;
  }

  /**
   * 是否全选
   */
  @computed
  get isSelectedAll() {
    if (!this.cartList || this.cartList.length == 0) {
      return false;
    }
    let listdata = [];
    let flag = false; // 防止一项都未选会出现全选的情况
    for (const cartItem of this.cartList) {
      listdata = cartItem.activityList;
      // console.log(listdata,'listdata3333');
      for (const item of cartItem.itemList) {
        if (this.getItemCanSelect(item, listdata)) {
          if (this.selectedItems[item.id]) {
            flag = true;
          } else {
            return false;
          }
        }
      }
    }
    return flag;
  }

  /**
   * 获取产品项是否可选
   * retailOrderTypeStatus 是否支持零售订单类型(1：支持 0：不支持)
   * monthlyOrderTypeStatus 是否支持复消订单(1：支持 0：不支持)
   */
  getItemCanSelect(item, cartList, num) {
    let list = [];
    let buyProduce;
    if (num) {
      if (cartList) {
        cartList.map((item, index) => {
          if (item.activityType == 6) {
            list.push(item);
            return true;
          }
        });
      }
    }
    const { saleZone = '' } = Stores.AppMod.userInfo || {};
    const {
      retailOrderTypeStatus,
      monthlyOrderTypeStatus,
      limitNum,
      itemStatus,
      allowDiscount,
      distributionRatio,
      saleMode // 2-销售专区
    } = item;
    if (this.onManaging) {
      return true;
    }
    if (num && this.distributionRatio != -1) {
      buyProduce = distributionRatio
        ? list.length
          ? true
          : distributionRatio.indexOf(this.distributionRatio) >= 0
        : false;
    } else {
      buyProduce = distributionRatio
        ? distributionRatio.indexOf(this.distributionRatio) >= 0
        : false;
    }
    if (this.isVipRebuy) {
      return true;
    }

    // if (this.isDiscountMode && !(allowDiscount || this.discount == 1)) {
    //   return false
    // }

    return (
      ((this.orderType == '1' && retailOrderTypeStatus == 1) ||
        (this.orderType == '2' && monthlyOrderTypeStatus == 1)) &&
      `${itemStatus}` == '1' &&
      (distributionRatio ? 1 : false) &&
      (limitNum == null ? true : limitNum > 0) &&
      !(saleZone == 1 && saleMode == 2)
    );
  }

  /**
   * 查看或收起套餐内容
   */
  @action
  showMoreCombination(cartIndex, index) {
    const { cartList } = this;
    if (cartList[cartIndex].itemList[index].hideMoreCombination) {
      cartList[cartIndex].itemList[index].hideMoreCombination = false;
    } else {
      cartList[cartIndex].itemList[index].hideMoreCombination = true;
    }
    this.cartList = cartList;
  }

  /**
   * 改变购物车商品项数量
   */
  @action
  changeItemNum(number, cartIndex, index, id, ingoreNum0 = false) {
    let cartList = [...this.cartList];
    cartList[cartIndex].itemList[index].itemNum = number;
    this.cartList = cartList;

    // 如果数量增减变化在延迟时间之内，并且是重复点击同一个商品，取消之前的回调，减少频繁回调请求接口
    if (this.timer && id === this.currentChangeId) {
      clearTimeout(this.timer);
      this.timer = null;
    }

    // 记录正在计时的商品
    this.currentChangeId = id;

    this.timer = setTimeout(() => {
      if ((!number || number <= 0 || !Number.isInteger(number)) && !ingoreNum0) {
        return;
      }
      !ingoreNum0 &&
        Serv.updateCartItemNum({
          id,
          itemNum: number
        });
      this.getDiscountBatch(null, cartIndex);
      this.getIncPriceShopMsg(cartList[cartIndex].gKey);
    }, 1000);
  }

  /**
   * 批量删除
   */
  deleteBatch = flow(function* (list = []) {
    if (!list || list.length <= 0) {
      for (const cartItem of this.cartList) {
        for (const item of cartItem.itemList) {
          if (this.selectedItems[item.id]) {
            list.push(item.id);
          }
        }
      }
    }

    if (list.length == 0) {
      Toast.info('请先选择产品', 1);
      return;
    }

    try {
      const { data, resultCode, resultMsg } = yield Serv.deleteBatch(list);

      if (resultCode == 0) {
        Toast.info('删除成功', 1);
        yield this.getCartList();
        //重新计算运费
        this.getFreight();
      } else {
        Toast.info('删除失败', 1);
      }
    } catch (error) {
      console.log('error: ', error);
    }
  });

  /**
   * 加价购合计对象，包含‘总数量’、‘金额’...
   */
  @computed
  get incPriceTotal() {
    let list = [...this.cartList];
    let total = [];
    // let total = {
    //   count: 0,
    //   money: 0,
    // };
    this.cartList.forEach((cartItem, index) => {
      total.push({ count: 0, money: 0 });
      if (cartItem.itemList.find((item) => this.selectedItems[item.id])) {
        let items = get(cartItem, 'incPriceShop.items', []);
        if (items.length > 0) {
          items.forEach((item) => {
            if (item.isSelected) {
              total[index].count += item.itemNum;
              // 指定金额加购
              if (cartItem.incPriceShop.incPriceType == 1) {
                total[index].money += item.itemNum * cartItem.incPriceShop.incPriceMoney;
              } else {
                // 指定折扣加购
                let list = [0, ...cartItem.incPriceShop.items];
                total.money += list.reduce((pre, next) =>
                  !next.isSelected
                    ? pre
                    : pre + next.salePrice * next.itemNum * cartItem.incPriceShop.incPriceMoney
                );
                total[index].money = +(total[index].money / 100).toFixed(2);
              }
            }
          });
        }
      }
    });
    console.log(total, '打印这个返回的是什么');
    return total;
  }

  /**
   * 合计总金额、bv
   */
  @computed
  get totals() {
    let totalAmount = 0;
    let totalBv = 0;
    for (const cartItem of this.cartList) {
      const { activityList = [], itemList } = cartItem;
      // 分组有产品选择
      let flag = false;
      for (const item of itemList) {
        const { id, price, itemNum, bv, discountBv, discount, promotionBv } = item;
        if (this.selectedItems[id]) {
          flag = true;
          totalAmount += price * itemNum;
          // totalBv = totalBv + bv * itemNum - (discountBv || 0);
          totalBv = totalBv + (promotionBv || bv) * itemNum;
          if (this.isDiscountMode) {
            totalAmount -= discount || 0;
          }
        }
      }
      if (!this.isDiscountMode && flag && activityList && activityList.length > 0 && this.isJoin) {
        for (const item of activityList) {
          const {
            achieve, // 是否满足
            reduceAmount // 优惠金额，如 已减100.00 返回 100.00
          } = item;
          if (achieve) {
            totalAmount -= reduceAmount || 0;
          }
        }
      }
    }
    if (this.isJoin) {
      this.incPriceTotal.map((item, index) => {
        totalAmount += item.money;
      });
    }
    // totalAmount += this.incPriceTotal.money;
    return { totalAmount, totalBv: parseInt(totalBv) };
  }

  /**
   * 切换促销 选择促销之后的确定 修改活动列表
   */
  @action
  switchActivity = (list) => {
    let activityIdList = [];
    list.forEach((item) => {
      if (+item.activityType === 3) {
        activityIdList.push(item.activityId);
      }
    });
    this.selectActivityId = activityIdList; // 已选满赠活动的数组集合赋值到mobx
    let cartIndex = -1;
    // this.allActivityItems = {};
    for (let i = 0; i < this.cartList.length; i++) {
      const { groupLabel, activityList = [] } = this.cartList[i];
      const activityIds = activityList
        ? activityList.map((item) => {
            return item.activityId;
          })
        : [];
      if (`${groupLabel}` == '6') {
        let flag = true;
        if (activityIds.length == list.length) {
          for (let j = 0; j < list.length; j++) {
            if (!activityIds.includes(list[j].activityId)) {
              flag = false;
              break;
            }
          }
        } else {
          flag = false;
        }

        if (flag) {
          cartIndex = i;
          break;
        }
      }
    }
    let [cartItemIndex, itemIndex] = this.switchIndexs;
    let incPriceIndex = cartItemIndex; // 记录获取加价购组
    if (cartIndex != cartItemIndex) {
      let { cartList } = this;
      const items = cartList[cartItemIndex].itemList.splice(itemIndex, 1);

      // 如果商品没有选中活动，则重置商品的优惠金额和BV
      if (!list || list.length == 0) {
        items[0].discount = 0;
        items[0].discountBv = 0;
      }

      if (cartIndex == -1) {
        // 新的分组, 放到数组头位
        incPriceIndex = 0;
        cartList.unshift({
          activityList: list,
          groupLabel: 6,
          groupLabelName: '普通',
          itemList: items
        });
        // 添加了新分组，旧的索引要+1
        cartItemIndex += 1;
      } else {
        // 没有新分组,
        incPriceIndex = cartIndex;
        cartList[cartIndex].itemList.unshift(items[0]);
      }

      if (cartList[cartItemIndex].itemList.length == 0) {
        // 如果删除的组在加价购组前面, 加价购组索引需要-1
        if (incPriceIndex > cartItemIndex) {
          incPriceIndex -= 1;
        }
        cartList.splice(cartItemIndex, 1);
      }
      this.cartList = this.addActivityProductsKeys(toJS(cartList));
      this.cartList = this.cartList.sort((a, b) => {
        return (b.activityList || []).length - (a.activityList || []).length;
      });
      this.selectedGiftListItems = [];
      if (this.isVipRebuy) {
        this.orderType = '10';
        this.distributionRatio = '1';
      }

      if (!this.isVipRebuy && this.orderType == '10') {
        this.orderType = '1';
        if (this.isDiscountMode && !this.isShopMasterMode) {
          this.discount = '1';
        } else {
          this.distributionRatio = '1';
        }
        this.getCartList();
      }
      console.log('cartList>>>>', toJS(this.cartList));
      this.getIncPriceShopMsg(this.cartList[incPriceIndex].gKey);
      this.getDiscountBatch();
    }
  };

  /**
   * 切换分组的促销
   *
   * @param {object} activityItem 当前取消的活动信息
   * @param {object} sectionActivityList 当前分组的活动信息-变化前的
   * @param {number} sectionIndex  当前分组的索引
   */
  @action
  switchSectionActivity = (activityItem, sectionActivityList, sectionIndex) => {
    //计算变化之后的新的activityList
    const oldActivityList = sectionActivityList;
    const newActivityList = oldActivityList.filter(
      (item) => item.activityId !== activityItem.activityId
    );

    // 查找要切换的活动组是否存在
    let cartIndex = -1;
    for (let i = 0; i < this.cartList.length; i++) {
      const { groupLabel, activityList = [] } = this.cartList[i];
      const activityIds = activityList
        ? activityList.map((item) => {
            return item.activityId;
          })
        : [];
      if (`${groupLabel}` == '6') {
        let flag = true;
        if (activityIds.length == newActivityList.length) {
          for (let j = 0; j < newActivityList.length; j++) {
            if (!activityIds.includes(newActivityList[j].activityId)) {
              flag = false;
              break;
            }
          }
        } else {
          flag = false;
        }

        if (flag) {
          cartIndex = i;
          break;
        }
      }
    }

    let incPriceIndex = sectionIndex; // 记录获取加价购组
    if (cartIndex != sectionIndex) {
      let { cartList } = this;
      const items = cartList[sectionIndex].itemList;

      // 如果商品没有选中活动，则重置商品的优惠金额和BV
      if (!newActivityList || newActivityList.length == 0) {
        items[0].discount = 0;
        items[0].discountBv = 0;
      }

      //当前分组不存在，组成新的分组， 放到数组头位
      if (cartIndex == -1) {
        incPriceIndex = 0;
        cartList.unshift({
          activityList: newActivityList,
          groupLabel: 6,
          groupLabelName: '普通',
          itemList: items
        });
        // 添加了新分组，旧的索引要+1
        sectionIndex += 1;
      } else {
        //分组已存在，把变化分组的商品插入到对应的分组里
        incPriceIndex = cartIndex;
        cartList[cartIndex].itemList.unshift(...items);
      }

      // 如果删除的组在加价购组前面, 加价购组索引需要-1
      if (incPriceIndex > sectionIndex) {
        incPriceIndex -= 1;
      }
      // 删除当前变化的分组
      cartList.splice(sectionIndex, 1);
      this.cartList = this.addActivityProductsKeys(toJS(cartList));
      this.cartList = this.cartList.sort((a, b) => {
        return (b.activityList || []).length - (a.activityList || []).length;
      });
      this.selectedGiftListItems = [];
      if (this.isVipRebuy) {
        this.orderType = '10';
        this.distributionRatio = '1';
      }

      if (!this.isVipRebuy && this.orderType == '10') {
        this.orderType = '1';
        if (this.isDiscountMode && !this.isShopMasterMode) {
          this.discount = '1';
        } else {
          this.distributionRatio = '1';
        }
        this.getCartList();
      }
      this.getIncPriceShopMsg(this.cartList[incPriceIndex].gKey);
      this.getDiscountBatch();
    }
  };

  /**
   * 给每个分组增加key
   */
  @action
  addActivityProductsKeys(selectedProducts) {
    selectedProducts.forEach((item, index) => {
      const { activityList } = item;
      if (!(activityList && activityList.length > 0)) {
        item.gKey = '';
      } else if (activityList.length == 1) {
        item.gKey = activityList[0].activityId;
      } else if (activityList.length > 0) {
        item.gKey = activityList
          .map((it) => it.activityId)
          .sort((a, b) => a - b)
          .join(',');
      }
    });
    return selectedProducts;
  }

  /**
   * 批量计算活动分组的优惠金额
   */
  getDiscountBatch = flow(function* (callback, cartItemIndex = this.cartIndex) {
    console.log('this.cartIndex', this.cartIndex);
    const list = [];
    this.cartList.forEach((cartItem, ind) => {
      let indevalue = 0;
      let activityIdValue = [];
      const { activityList = [], itemList = [] } = cartItem;
      const activityInfoReqDtoList = [];

      for (const item of itemList) {
        if (this.selectedItems[item.id]) {
          activityInfoReqDtoList.push(item);
        }
      }
      if (activityList && activityList.length > 0 && this.isJoin) {
        if (activityInfoReqDtoList && activityInfoReqDtoList.length > 0) {
          list.push({
            activityInfoReqDtoList: activityList,
            itemfoReqDtoList: activityInfoReqDtoList,
            distributionRatio: this.distributionRatio,
            discount: this.discount,
            orderType: this.orderType
          });
          for (const item of activityList) {
            if (+item.activityType === 3) {
              activityIdValue.push(item.activityId);
              indevalue = ind;
            }
          }
          // this.handleSelectedGiftListFan(
          //   indevalue,
          //   Array.isArray(activityIdValue)
          //     ? activityIdValue.join(',')
          //     : activityIdValue,
          // ); // 反向自动选择赠品
        }
      } else {
        if (this.isDiscountMode || Stores.AppMod.isLD) {
          list.push({
            activityInfoReqDtoList: [],
            itemfoReqDtoList: activityInfoReqDtoList,
            distributionRatio: this.distributionRatio,
            discount: this.discount,
            orderType: this.orderType
          });
        }
      }
    });
    if (list && list.length == 0) {
      this.activityDiscountInfoListGkey = [];
      this.freeShippingData = { amount: 0, showType: 0 };
      return;
    }
    const params = {
      calculateDiscountReqDtoList: list,
      distributionRatio: this.distributionRatio,
      orderType: this.orderType
    };
    if (this.discount) {
      params.discount = this.discount;
    }
    try {
      const { data, resultCode, resultMsg } = yield Serv.getDiscountBatch(params);
      Toast.hide();
      if (+resultCode !== 0 && !this.onManaging) {
        this.handleActivityCommonTip('提示', resultMsg);
      }
      if (data && data.length > 0) {
        this.queryReturnData = data; // 将query返回的分组活动信息包含的多买多赠存到mobox;
        this.totalPureAmount = 0;
        let gKeyData = data;
        gKeyData.forEach((gItem, index) => {
          // const { activityDiscountInfoList = [], itemDiscountInfoList = [] } = gItem;
          const activityInfoReqDtoList = get(
            params,
            `calculateDiscountReqDtoList[${index}].activityInfoReqDtoList`
          );
          // 获取gkey
          gItem.gKey = this.getActivityListKey(activityInfoReqDtoList);
        });

        this.activityDiscountInfoListGkey = gKeyData;
        console.log('activityDiscountInfoListGkey123', toJS(this.activityDiscountInfoListGkey));
        for (let i = 0; i < data.length; i++) {
          const groupItem = data[i];
          const { activityDiscountInfoList = [], itemDiscountInfoList = [], total = 0 } = groupItem;
          this.totalPureAmount += total;
          // 活动分组的提示语
          (this.cartList[cartItemIndex] ? this.cartList[cartItemIndex].activityList || [] : []).map(
            (_i) => {
              (activityDiscountInfoList || []).map((_j) => {
                if (_i.activityId === _j.activityId && _j.activityType != 3) {
                  this.jtInfo = {
                    ...this.jtInfo,
                    [_i.activityId + `${cartItemIndex}`]: _j.reminder
                  };
                }
              });
            }
          );
          const activityIds =
            activityDiscountInfoList && activityDiscountInfoList.length > 0
              ? activityDiscountInfoList.map((item) => {
                  return item.activityId;
                })
              : [];
          // for (let i = 0; i < this.cartList.length; i++) {
          const { activityList = [], itemList = [] } = this.cartList[i];
          // 判断两个分组是否相同
          let flag = true;
          if (activityIds && activityList && activityIds.length == activityList.length) {
            for (let j = 0; j < activityList.length; j++) {
              if (!activityIds.includes(activityList[j].activityId)) {
                flag = false;
                break;
              }
            }
          } else {
            flag = false;
          }
          // 找到相同分组
          if (this.isDiscountMode || flag) {
            // 设置活动项优惠
            for (const item of activityDiscountInfoList) {
              const { activityId } = item;
              if (activityList) {
                for (let j = 0; j < activityList.length; j++) {
                  if (activityList[j].activityId == activityId) {
                    this.cartList[i].activityList[j] = {
                      ...this.cartList[i].activityList[j],
                      ...item
                    };
                    break;
                  }
                }
              }
              // 设置产品项优惠
              for (const item2 of itemDiscountInfoList) {
                const { itemSerial, discount, discountBv, bv, price, promotionBv } = item2;
                if (itemList) {
                  for (let j = 0; j < itemList.length; j++) {
                    if (itemList[j].itemSerial == itemSerial) {
                      this.cartList[i].itemList[j] = {
                        ...this.cartList[i].itemList[j],
                        //这里有些情况没有塞进去discount
                        ...{
                          discount,
                          discountBv,
                          lessBv: bv,
                          lessPrice: price,
                          promotionBv
                        }
                      };
                      break;
                    }
                    break;
                  }
                }
              }
            }
            continue;
            // break;
          }
          // }
        }
      }
      // setTimeout(()=>{
      let infoList = data;
      let twoArr = Array.isArray(infoList) && infoList.map((m) => m.itemDiscountInfoList).flat(1);
      let twoArrKeys = (twoArr || []).map((m) => m.itemSerial) || [];
      console.log(twoArr, '--->twoArr');
      const { activityList, itemList } = this.cartList[cartItemIndex] || {};
      (itemList || []).forEach((fi) => {
        if (twoArrKeys.includes(fi.itemSerial)) {
          let { discountBv, discount } = twoArr.find((f) => f.itemSerial === fi.itemSerial) || {};
          fi.discount = discount;
          fi.discountBv = discountBv;
        }
      });

      const cartItem = this.cartList[cartItemIndex];

      let promiseHandleSelectedGiftListFan = [];
      (toJS(this.cartList) || []).map((cartItem, cartIdx) => {
        cartItem.itemList.map((_it) => {
          if (
            Object.keys(this.selectedItems).some((_v) => {
              return _v == _it.id && this.selectedItems[_it.id];
            })
          ) {
            // 商品是被选中状态
            // 且参加满赠活动 需要请求gift/list/batch
            if ((cartItem.activityList || []).some((_act) => _act.activityType == 3)) {
              let activityIdValue = (cartItem.activityList || [])
                .filter((f) => f.activityType == 3)
                .map((m) => m.activityId);
              promiseHandleSelectedGiftListFan.push({
                cartItemIndex: cartIdx,
                activityIdValue: Array.isArray(activityIdValue)
                  ? activityIdValue.join(',')
                  : activityIdValue
              });
            }
          }
        });
      });

      //重算运费
      this.getFreight();

      yield Promise.all(
        promiseHandleSelectedGiftListFan.map(async (item, idx) => {
          console.log('请求queryBatch', idx, item);
          await this.handleSelectedGiftListFan(item.cartItemIndex, item.activityIdValue);

          await this.queryJt(item.cartItemIndex);
        })
      ).then((res) => {
        console.log('queryBatch接口每一项满赠活动重新请求赠品和提示语 success');
      });

      // let activityIdValue =
      //   cartItem.activityList &&
      //   cartItem.activityList
      //     .filter(f => f.activityType == 3)
      //     .map(m => m.activityId);
      // this.handleSelectedGiftListFan(
      //   cartItemIndex,
      //   Array.isArray(activityIdValue)
      //     ? activityIdValue.join(',')
      //     : activityIdValue,
      // ); // 反向自动选择赠品

      // this.queryJt(cartItemIndex);
      // },100)
    } catch (error) {
      console.log(error);
      callback && callback();
    }
  });

  /**
   * 获取运费
   */
  getFreight = flow(function* () {
    // 如果还没选择地址，不计算运费
    if (!this.addressInfo || !this.addressInfo.cityCode || this.distributionRatio === -1) {
      return;
    }

    const goodsList = [];
    for (const goodsSection of this.cartList) {
      for (const goods of goodsSection.itemList) {
        const isSelected = this.selectedItems[goods.id];
        if (isSelected) {
          const activityList = goodsSection.activityList || [];
          goodsList.push({
            activityIdList: activityList.map((item) => item.activityId),
            itemNum: goods.itemNum,
            itemSerial: goods.itemSerial,
            itemPrice: goods.price,
            skuSerial: goods.skuSerial
          });
        }
      }
    }

    if (!goodsList.length) {
      this.freeShippingData = { amount: 0, showType: 0 };
      return;
    }

    let params = {
      items: goodsList,
      areaCode: this.addressInfo.cityCode,
      deliveryType: '1',
      orderProperty: this.distributionRatio,
      totalOrderAmount: (this.totals && this.totals.totalAmount) || 0,
      couponFreight: 0,
      availableItemIds: []
    };

    try {
      const { data, resultCode } = yield Serv.getFreight(params);

      if (resultCode == 0) {
        this.freeShippingData = data;
      } else {
        this.freeShippingData = { amount: 0, showType: 0 };
      }
    } catch (e) {
      this.freeShippingData = { amount: 0, showType: 0 };
      console.log('getFreight e', e);
    }
  });

  /**
   * 活动下单，通用提示处理
   */
  handleActivityCommonTip(title = '', resultMsg, callback) {
    this.modalShow = true;
    this.modalContent = resultMsg;
    // alert(title, resultMsg, [
    //   {
    //     text: '确认',
    //     onPress: () => {
    //     },
    //   }
    // ]);
    //  Modal.show({
    //   content: resultMsg,
    //   closeOnAction: true,
    //   actions: [
    //     {
    //       key: 'online',
    //       text: '已知晓',
    //       primary: true,
    //     },
    //   ],
    // })
  }

  /**
   * 获取加价购信息
   */
  getIncPriceShopMsg = flow(function* (gKey) {
    const list = [];
    const $cartList = toJS(this.cartList);
    const cartItem = this.cartList.find((cart, index) => {
      if (cart.gKey == gKey) {
        // 重新请求加价购，需要先把旧的加价购置空
        this.cartList[index].incPriceShop = null;
        this.viewInstance.forceUpdate();
        return true;
      }
    });

    const { activityList = [], itemList = [] } = cartItem || {};
    // 如果活动不包含加价购物，则返回
    const hasIncPriceAct =
      activityList && activityList.some((activity) => activity.activityType == 4);
    if (!hasIncPriceAct) return;
    const { activityTitle: $activityTitle } =
      (activityList || []).find((activity) => activity.activityType == 4) || {};
    if (activityList && activityList.length > 0 && this.isJoin) {
      const activityInfoReqDtoList = [];

      for (const item of itemList) {
        if (this.selectedItems[item.id]) {
          activityInfoReqDtoList.push(item);
        }
      }
      if (activityInfoReqDtoList.length > 0) {
        list.push({
          activityInfoReqDtoList: activityList,
          itemfoReqDtoList: activityInfoReqDtoList,
          distributionRatio: this.distributionRatio,
          discount: this.discount,
          orderType: this.orderType
        });
      }
    }
    if (list.length == 0) return;

    const params = {
      calculateDiscountReqDtoList: list,
      distributionRatio: this.distributionRatio,
      discount: this.discount,
      orderType: this.orderType
    };
    try {
      const { data, resultCode, resultMsg } = yield Serv.getIncPriceShopMsg(params);
      // if (+resultCode !== 0) {
      //   this.handleActivityCommonTip('提示', resultMsg);
      // }
      if (resultCode == 0) {
        let list = $cartList;
        let cartItemIndex = -1;
        this.cartList.some((cart, index) => {
          if (cart.gKey == gKey) {
            cartItemIndex = index;
            return true;
          }
        });
        // 是否是盲盒活动
        const isRand = get(data, 'random', 0);
        list[cartItemIndex].incPriceShop = {
          items: get(data, 'itemRespDtoList', []).map((item, i) => {
            // 盲盒活动默认取第一个选中
            if (isRand) {
              return {
                ...item,
                itemNum: i === 0 ? get(data, 'increment', 0) : 0,
                isSelected: i == 0
              };
            } else {
              // 只有一个商品，默认选中
              // 如果那个商品是多规格商品，不选中
              const isUnion = get(data, 'itemRespDtoList', []).length === 1;
              const canSelect = get(data, 'increment', 0) > 0;
              const isNormalProduct = (item.subGiftItemSelectRespDtoList || []).length == 0;

              const defaultSelect = isUnion && isNormalProduct && canSelect;
              return {
                ...item,
                itemNum: defaultSelect ? 1 : 0,
                isSelected: defaultSelect
              };
            }
          }),
          rand: isRand,
          shared: get(data, 'shared', 1),
          blessingBagAlias: get(data, 'blessingBagAlias', ''),
          blessingBagImg: get(data, 'blessingBagImg', ''),
          maxIncPriceNum: get(data, 'increment', 0),
          incPriceMoney: get(data, 'priceIncrease', 0),
          incPriceType: get(data, 'priceIncreaseType', 0),
          activityTitle: $activityTitle,
          selectMethod: get(data, 'selectMethod', 0)
        };
        this.cartList = list;
        this.viewInstance.forceUpdate();

        // 阶梯促销加价购 捕获提示语
        let findActivityId = list[cartItemIndex].activityList.find(
          (item) => item.activityType == 4
        ).activityId;
        this.jtInfo = {
          ...this.jtInfo,
          [findActivityId + `${cartItemIndex}`]: data.reminder
        };
      }
    } catch (error) {
      console.log('error', error);
    }
  });

  /**
   * 是否有1：2配货比例的弹窗
   *
   */
  getDistributionTip = flow(function* (params) {
    try {
      const result = yield Serv.getDistributionTip(params);
      if (result && result.resultCode == '0') {
        return result.data == 1;
      }
      return false;
    } catch (error) {
      return false;
    }
  });
  @action
  closeModal() {
    this.modalShow = false;
  }

  /**
   * 查询是否绑定过微信
   */
  queryBindFlag = flow(function* () {
    if (Stores.AppMod.isInternationalized) return true; // 国际版不需要绑定微信
    try {
      const result = yield Serv.queryBindFlag();
      if (result && result.resultCode === '0') {
        return result.data; // 0未关联 1已关联
      } else {
        return 1;
      }
    } catch (err) {
      return 1;
    }
  });

  /**
   *  获取跳转链接
   *
   */
  getWechatLoginUrl = flow(function* (params) {
    try {
      const { data, resultCode, resultMsg } = yield Serv.getWechatLoginUrl(params);
      if (+resultCode === 0) {
        return data;
      }
    } catch (error) {}
  });
  /**
   *  分享记录（分享之前调用）
   *
   */
  ShareCart = flow(function* (itemList) {
    console.log('抛出', itemList);
    let params = {
      shareSource: 1,
      bizCartAddReqDtos: [...itemList]
    };
    try {
      const { data, resultCode, resultMsg } = yield Serv.ShareCart(params);
      if (+resultCode === 0) {
        return data;
      }
    } catch (error) {}
  });

  // 多规格商品
  getMoreMultiList = flow(function* (id) {
    try {
      const { data } = yield Serv.getMoreMultiList(id);
      if (data && data.subItem) {
        this.moreSpecificationsData = data.subItem || [];
      }
      return data;
    } catch (e) {}
  });

  /**
   * 获取用户地址列表
   *
   * @memberof ShoppingCartMod
   */
  getAddressList = flow(function* () {
    try {
      const { data } = yield (
        getThinUserState() || getIsUnsubscribeOrSleep() ? Serv.getLogistics : Serv.getAddressList
      )();
      if (data && data.list) {
        const list = data.list || [];
        this.addressInfo = list.find((address) => address.status === 1) || list[0] || {};
      }
      return data;
    } catch (e) {}
  });

  // 获取产品列表
  getRecommendProductList = flow(function* (loadMore) {
    this.recommendListData.isLoading = true;
    let pageNum = 1;
    if (!loadMore) {
      this.recommendListData.data = [];
    } else {
      pageNum = this.recommendListData.pageNum + 1;
    }

    const params = {
      // 前端类目id集合
      frontDirIdList: [],
      // 品牌id集合
      brandIdList: [],
      // 角标id集合
      cornerIdList: [],
      // 用于区分显示的文案是类目还是搜索内容
      keyword: '',
      // 排序方式 1:时间 2:销量 3:价格 4:综合(默认)
      sortType: 4,
      // 排序升降序：ASC:升序；DESC：降序
      sortOrder: 'DESC',
      // 是否有库存
      inStock: 1,
      // 产品id列表
      itemIdList: [],
      itemProperties: '',
      distributionRatio: ''
    };

    try {
      const { data = {} } = yield Serv.getRecommendProductList({ pageSize: 10, pageNum }, params);
      this.recommendListData.isLoading = false;
      data.list = data.list.map((item) => {
        return {
          ...item,
          paused: item.paused === undefined ? true : item.paused,
          isFirstClick: item.isFirstClick === undefined ? true : item.isFirstClick
        };
      });
      if (params.pageNum !== 1) {
        const arr = this.recommendListData.data || [];
        this.recommendListData.data = arr.concat(data.list || []);
      } else {
        this.recommendListData.data = data.list || [];
      }
      // 重置页数等信息
      this.recommendListData.pageNum = data.pageNum;
      this.recommendListData.pages = data.pages;
    } catch (error) {}
  });

  validateSwitchClose = flow(function* (params) {
    try {
      return yield Serv.validateSwitchClose(params);
    } catch (e) {
      console.log('error', e);
    }
  });

  @action
  clearData() {
    this.onManaging = false;
    this.cartList = [];
    this.cartCount = 0;
    this.orderType = '1';
    this.distributionRatio = '';
    this.discount = '';
    this.selectedItems = {};
    this.isJoin = true;
    this.switchIndexs = [];
    this.modalData = {
      show: false,
      content: ''
    };
    this.moreSpecificationsData = [];
    this.addressInfo = {};
    this.selectedGiftListItems = [];
  }
}

const shoppingCartMod = new ShoppingCartMod();
export default shoppingCartMod;



// WEBPACK FOOTER //
// ./src/pages/Shop/ShoppingCart/ShoppingCartMod.js